import React from 'react'
import { StyledSection } from './Section.styled'

export const Section = (props) => {
  return <StyledSection {...props} />
}
